import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Disable common DevTools shortcuts in production
if (import.meta.env.PROD) {
  document.addEventListener("keydown", (e) => {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key)) ||
      (e.ctrlKey && e.key === "U")
    ) {
      e.preventDefault();
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
